module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-tag"
  }, [_vm._t("icon", [_c('rt-icon', {
    attrs: {
      "name": _vm.icon,
      "size": "14"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "rt-tag-text"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a58c704"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tag/rtTag.vue
// module id = 1427
// module chunks = 116